<template>
  <div class="pie-chart-v2-main" ref="pieMain">
    <div class="pie-chart-v2-svg-container" ref="svgMainContainer">
      <svg class="pie-chart-v2-svg" ref="svgContainer">
        <path class="pie-chart-v2-path" v-for="(p, i) in pieData" :key="i" :d="p['svgpath']" :fill="p['color']"
          :style="{ transformOrigin: `${center['x']}px ${center['y']}px`, display: p['show'] ? '' : 'none' }"
          @mouseover="pieMouseOver" @mouseout="pieMouseOut" />
      </svg>
    </div>
    <div class="pie-chart-v2-legend">
      <div v-for="(p, i) in pieData" :key="i" class="pie-chart-v2-legend-container" ref="legendContainer" @mouseover="legendMouseOver" @mouseout="legendMouseOut"
        @click="legendClicked(p)">
        <div class="pie-chart-v2-legend-color" :style="{ backgroundColor: p['show'] ? p['color'] : 'transparent', borderColor: p['color'] }" :color="p['color']"></div>
        <div class="pie-chart-v2-legend-text" :style="{ opacity: p['show'] ? '1' : '0.5' }">{{ p['name'] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      radius: 0,
      center: { x: 0, y: 0 },
      padding: 20,
      
      pieItemOnLegendHover: null,
      legendItemOnPieHover: null,
    }
  },
  props: {
    colors: { type: Array, default: function() {
      return [
        '#FF0000', // Color 01 RED
        '#008000', // Color 02 GREEN
        '#f1f100', // Color 03 YELLOW
        '#0000FF', // Color 04 BLUE
        '#00FF00', // Color 05 LIME
        '#00FFFF', // Color 06 AQUA
        '#FF00FF', // Color 07 MAGENTA
        '#FF1493', // Color 08 DEEPPINK
        '#F5F5DC', // Color 09 BEIGE
        '#D3D3D3', // Color 10 LIGHTGRAY
        '#800000', // Color 11 MAROON
        '#ADD8E6', // Color 12 LIGHTBLUE
        '#FFC0CB', // Color 13 PINK
        '#808000', // Color 14 OLIVE
        '#2f4f4f', // Color 15 DARKSLATEGRAY
        '#00fa9a', // Color 16 MEDIUMSPRINGGREEN
        '#fa8072', // Color 17 SALMON
      ]
    } },
    pieData: { type: Array, default: function() { return [] } }
  },
  methods: {
    drawPie: function(startAngle, endAngle) {
      let angleSize = endAngle - startAngle;

      let arcStart = this.getCircleCoordinate(startAngle);
      let arcEnd = this.getCircleCoordinate(endAngle);
      let arcLine = `${this.radius} ${this.radius} 0 ${angleSize >= 180 ? 1 : 0} 1 ${arcEnd['x']} ${arcEnd['y']}`;

      if (angleSize == 360) {
        arcEnd = this.getCircleCoordinate(180);
        let arc1 = `A${this.radius} ${this.radius} 0 0 1 ${arcEnd['x']} ${arcEnd['y']}`;
        let arc2 = `A${this.radius} ${this.radius} 0 0 0 ${arcEnd['x']} ${arcEnd['y']}`;
        return `M${arcStart['x']} ${arcStart['y']} ${arc1} M${arcStart['x']} ${arcStart['y']} ${arc2}`;
      } else {
        let startPoint = `${this.center['x']} ${this.center['y']}`;
        return `M${startPoint} L${arcStart['x']} ${arcStart['y']} A${arcLine} L${startPoint}`;
      }
    },
    getCircleCoordinate: function(angle) {
      let angleInRad = angle * Math.PI / 180;
      return { x: (this.radius * Math.sin(angleInRad)) + this.center['x'], y: this.center['y'] - (this.radius * Math.cos(angleInRad)) };
    },
    getPiePointForText: function(pos1, pos2) {
      let midPoint = {
        x: (pos1['x'] + pos2['x']) / 2,
        y: (pos1['y'] + pos2['y']) / 2
      }
      return {
        x: (pos1['x'] + midPoint['x']) / 2,
        y: (pos1['y'] + midPoint['y']) / 2
      }
    },

    svgSizeChanged: function(e) {
      let mainContainerRect = this.$refs['pieMain'];
      if (e) {
        mainContainerRect = e[0]['target'].getBoundingClientRect();
      }
      let diameter = mainContainerRect.height < mainContainerRect.width ? mainContainerRect.height : mainContainerRect.width; // Getting the lower size of the height and width to get the circle diameter
      this.center['x'] = mainContainerRect.width / 2;
      this.center['y'] = mainContainerRect.height / 2;
      this.radius = (diameter - (this.padding * 2)) / 2;

      if (this.pieData.length > 0) {
        this.formatPieData();
      }
    },
    formatPieData: function() {
      let shownPieData = this.pieData.filter(p => p['show']);
      let total = shownPieData.reduce((a, b) => a + b['value'], 0);
      let startAngle = 0;
      this.pieData.forEach((p, i) => {
        if (p['show']) {
          let angle = p['value'] / total * 360;
          let startArc = startAngle;
          let endArc = startAngle + angle;
  
          let perc = (p['value'] / total * 100).toFixed(2);
  
          this.$set(p, 'svgpath', this.drawPie(startArc, endArc));
          this.$set(p, 'color', this.colors[i]);
          this.$set(p, 'percentage', perc);
          this.$set(p, 'angleDetails', `${startArc},${endArc}`);
  
          startAngle += angle;
        }

      })

      this.$nextTick(() => {
        this.clearSvgPercentages();
        this.placePercentage();
      });
    },

    placePercentage: function() {
      let shownPieData = this.pieData.filter(p => p['show']);
      shownPieData.forEach(p => {
        let angles = p['angleDetails'].split(',').map(d => Number(d));
        let midAngle = ((angles[1] - angles[0]) / 2) + angles[0];
        let position = this.getCircleCoordinate(midAngle);
        let textPoint = this.getPiePointForText(position, this.center);

        let text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        text.setAttribute('x', textPoint['x']);
        text.setAttribute('y', textPoint['y']);
        text.setAttribute('text-anchor', 'middle');
        text.style.pointerEvents = 'none';
        text.innerHTML = `${p['percentage']}%`;
        this.$refs['svgContainer'].appendChild(text);
      })
    },
    clearSvgPercentages: function() {
      let texts = Array.from(this.$refs['svgContainer'].getElementsByTagNameNS('http://www.w3.org/2000/svg', 'text'));
      if (texts.length > 0) {
        texts.forEach(t => this.$refs['svgContainer'].removeChild(t));
      }
    },

    legendClicked: function(item) {
      let pieIndex = this.pieData.findIndex(p => JSON.stringify(p) == JSON.stringify(item));
      this.pieData[pieIndex]['show'] = !this.pieData[pieIndex]['show'];

      this.formatPieData();
    },
    legendMouseOver: function(e) {
      let legendColorEl = null;
      if (e.target.className == 'pie-chart-v2-legend-container') {
        legendColorEl = e.target.getElementsByClassName('pie-chart-v2-legend-color')
      } else {
        legendColorEl = e.target;
      }

      let allPie = Array.from(this.$refs['svgContainer'].getElementsByTagNameNS('http://www.w3.org/2000/svg', 'path'));
      let hoverColor = legendColorEl[0].getAttribute('color');
      this.pieItemOnLegendHover = allPie.find(a => a.getAttribute('fill') == hoverColor);
      
      if (this.pieItemOnLegendHover) {
        this.pieItemOnLegendHover.style.transform = 'scale(1.05)';
      }
    },
    legendMouseOut: function() {
      if (this.pieItemOnLegendHover) {
        this.pieItemOnLegendHover.style.transform = '';
      }
    },

    pieMouseOver: function(e) {
      let container = Array.from(this.$refs['legendContainer']);
      let allLegendColors = container.map(c => c.children[0]);
      this.legendItemOnPieHover = allLegendColors.find(c => c.getAttribute('color') == e.target.getAttribute('fill'));
      
      if (this.legendItemOnPieHover) {
        this.legendItemOnPieHover.parentNode.style.fontWeight = 'bold';
      }
    },
    pieMouseOut: function() {
      if (this.legendItemOnPieHover) {
        this.legendItemOnPieHover.parentNode.style.fontWeight = '';
      }
    },

    placePointer: function(pos) { // For Testing
      let pointMarker = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      pointMarker.setAttribute('cx', pos['x']);
      pointMarker.setAttribute('cy', pos['y']);
      pointMarker.setAttribute('r', this.radius * 0.01);
      pointMarker.setAttribute('fill', 'black');
      pointMarker.setAttribute('stroke', 'none');
      this.$refs['svgContainer'].appendChild(pointMarker);
    }
  },
  mounted() {
    let observer = new ResizeObserver(this.svgSizeChanged);
    observer.observe(this.$refs['svgMainContainer']);

    if (this.pieData.length > 0) {
      this.pieData.forEach(v => this.$set(v, 'show', true));
    }
  },
  watch: {
    pieData: function(val) {
      this.clearSvgPercentages();
      if (val.length > 0) {
        val.forEach(v => this.$set(v, 'show', true));
        this.formatPieData();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.pie-chart-v2-main {
  height: 100%;
  width: 100%;
  display: flex;
  font-size: 12px;

  > .pie-chart-v2-svg-container {
    width: 100%;
    height: 100%;
      
    > .pie-chart-v2-svg {
      height: 100%;
      width: 100%;
  
      > .pie-chart-v2-path {
        transition: 0.3s;
  
        &:hover {
          transform: scale(1.05);
        }
      }
    }
  }

  > .pie-chart-v2-legend {
    width: 50%;
    max-width: 200px;
    height: 100%;
    overflow-y: auto;

    > .pie-chart-v2-legend-container {
      display: flex;
      align-items: center;
      margin: 5px;

      &:hover {
        font-weight: bold;
      }

      > .pie-chart-v2-legend-color {
        min-height: 20px;
        min-width: 20px;
        height: 20px;
        width: 20px;
        border-radius: 5px;
        border-style: solid;
        border-width: 3px;
        pointer-events: none;
      }

      > .pie-chart-v2-legend-text {
        margin-left: 5px;
        pointer-events: none;
      }
    }
  }
}
</style>